import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
  CtBinaryOperator,
  CtControlConfiguration,
  CTFieldInfos,
  CtFormContainerHelper,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtSelectControlOptions,
  CtSortOrderDescriptorParameter,
  CtThemeTypes
} from "@ctsolution/ct-framework";
import {environment} from "../../../../../../environments/environment";
import {RoleService} from "../../../../../_core/lib/role.service";

const UserWorkingHoursWorkOrderControl: CTFieldInfos = CTFieldInfos.create({
  IsDTO: true,
  Field: "WorkOrder",
  Type: "WorkOrderDTO",
  IsNullable: false,
  ControlType: "Lookup",
  LookupInfos: {
    RemoteEndpoint: `${environment.dev.REST_API_SERVER}/WorkOrder/Lookup`,
    CodeField: "Code",
    DescriptionField: "Description",
    IncrementalSearch: true
  },
} as CTFieldInfos);

export enum WorkOrderMacroType {

  IN_ESECUZIONE = 2,
  ATTIVO = 3

}

@Component({
  selector: 'app-user-working-hours-work-order-control',
  template: `
    <ct-control *ngIf="configuration" [configuration]="configuration"></ct-control>`
})
export class UserWorkingHoursWorkOrderControlComponent implements AfterViewInit {

  configuration: CtControlConfiguration = CtControlConfiguration
  .create(this.ctFormContainerHelper
    .getCTFormControlByCTFieldInfo(UserWorkingHoursWorkOrderControl))
  .setTheme(CtThemeTypes.MATERIAL)

  viewModel = {

    isAdministrator: false

  }

  constructor(private role: RoleService, private ctFormContainerHelper : CtFormContainerHelper) {
  }

  async ngAfterViewInit() {

    this.viewModel.isAdministrator = await this.role.is.administrator();

    this.setup();

  }

  setup() {

    this.configuration
      .configureOptions<CtSelectControlOptions>(options => {

        if (!options) options = CtSelectControlOptions.create();

        options
          .setLookupFilter((value: string | null | number | undefined) => {

            const filters: CTModelDatatableFilter[] = [];

            filters
            .push(
              CTModelDatatableFilter
              .create()
              .setValue(false)
              .setField('Quotation')
              .setOperatorType(CtBinaryOperator.Equal))

            if (value) {

              filters
              .push(
                CTModelDatatableFilter
                  .create()
                  .setField("[Code] is not null AND Contains([Code], ?)")
                  .setValue([value])
                  .setOperatorType(CtBinaryOperator.OrOperator),
                CTModelDatatableFilter
                  .create()
                  .setField("[Name] is not null AND Contains([Name], ?)")
                  .setValue([value])
                  .setOperatorType(CtBinaryOperator.OrOperator)
              );

            }

            if (!this.viewModel.isAdministrator) {

              filters
                .push(
                  CTModelDatatableFilter
                    .create()
                    .setValue([WorkOrderMacroType.IN_ESECUZIONE, WorkOrderMacroType.ATTIVO])
                    .setField('State.Type==?')
                    .setOperatorType(CtBinaryOperator.BitwiseOr))



            }

            const operators = CtModelDatatableOperators
              .create()
              .setFilters(filters);

            operators
              .Pagination
              ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Name')))

            return operators;

          })
          .setNullValueEnabled(true)
          .notifyValuesUpdated()

      });

  }

}
